import React from 'react';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "../storeWire";

function Chain(props) {
    return (
        <Provider store={store}>
            <BrowserRouter>
                {props.children}
            </BrowserRouter>
        </Provider>
    );
}

export default Chain;
